/**
 * Display formatting for the raw integer pricing values the API returns
 * (basis points, integer cents). These are UI-only presentation helpers —
 * they never feed back into a payload, so producing a human-readable string
 * alongside the raw integer is safe and float-free.
 */

export function formatBasisPoints(basisPoints: number): string {
  return `${basisPoints} (${(basisPoints / 100).toFixed(2)}%)`
}

export function formatCents(cents: number): string {
  return `${cents} (EUR ${(cents / 100).toFixed(2)})`
}

export function formatCurrencyCode(code: string): string {
  return code.toUpperCase()
}
